module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/sort-1-b93f4d50971169e1ea2a6df4decb167a.svg";